export const pickupPoint = {
  state: {
    type: 'tabs',
    name: 'pickup-point',
    value: null,
    inputs: [],
    header: 'Адреса пунктов выдачи заказов',
  },
};
